export enum ReservedScheduleTypeEnum {
  Livance = 1,
  Porto = 2,
  BizDev = 4,
}
